<template>
  <v-card class="pa-8 d-flex flex-column justify-space-between h-100" elevation="0" style="border-radius: 16px;">

    <div class="kpiHeaderTitle">
      {{ title }}
    </div>

    <div class="kpi-content">
      <div v-if="!hasData" class="kpi-empty">
        {{ emptyText }}
      </div>
      <div v-else class="kpi-value">
        {{ value }}
      </div>
    </div>

    <div class="mt-4">
      <loader-button
          :fullWidth="true"
          :label="btnLabel || 'Voir plus'"
          :disabled = "!hasData"
          @callback="widgetAction"
      />
    </div>
  </v-card>
</template>

<script lang="ts">
import {defineComponent} from 'vue'
import LoaderButton from '@/framework/base/components/LoaderButton.vue'
import {WidgetInfo} from "@/generated/classes/DashboardWidget.ts";

export default defineComponent({
  name: 'KpiWidget',

  components: {
    LoaderButton
  },

  props: {
    id: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    btnLabel: {
      type: String,
      required: true
    },
    emptyText: {
      type: String,
      default: "Aucune donnée disponible"
    }

  },
  computed: {
    hasData() {
      return this.value > 0
    }
  },
  methods: {
    widgetAction() {
      const widgetInfo = new WidgetInfo();
      widgetInfo.id = this.id;
      widgetInfo.label = this.title;

      this.$emit("widgetAction", widgetInfo);
    }
  }
})
</script>

<style scoped>
.kpiHeaderTitle {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: -0.01em;
  color: #010606;
  margin-bottom: 40px;
}

.kpi-content {
  flex: 1;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}

.kpi-empty {
  font-size: 14px;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0;
  color: rgb(var(--v-theme-secondary50));
  text-align: left;
}

.kpi-value {
  font-size: 57px;
  font-weight: 600;
  line-height: 64px;
  letter-spacing: -0.04em;
  color: rgb(var(--v-theme-secondary10));
  text-align: left;
}
</style>
